import React from "react";
import "../App.css";
import customer from "../assets/images/customer.png";

const SidePanel = ({ isCollapsed }) => {

  return (
    <div
      className={`flex transition-all duration-300 side-panel ${isCollapsed ? "w-16" : "w-64"
        }`}
    >
      {/* Sidebar */}
      <aside className="w-64 bg-[#181818] text-[#B6B6B6] flex flex-col ">
        {/* Navigation */}
        <nav className="mt-8 flex-grow p-2">
          <ul>

            <li className="mb-2">
              <a
                href="/customer"
                className="flex items-center gap-4 p-2 rounded hover:bg-gray-700 w-full"
              >
                <img
                  src={customer}
                  alt={"customer-icon"}
                  className="w-6 h-6"
                />
                {!isCollapsed && (
                  <span className="text-sm">Customers</span>
                )}
              </a>
            </li>

          </ul>
        </nav>

      </aside>
    </div>
  );
};

export default SidePanel;
